import React, { useState } from 'react';
import axios from 'axios';
import { API } from '../config';

const DisclaimerModal = ({ onAgree }) => {
  const [isAgreed, setIsAgreed] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleAgree = async () => {
    if (!isAgreed) return;
    setLoading(true);
    try {
      await axios.post(`${API}/me/accept-terms`);
      onAgree();
    } catch (err) {
      alert('Failed to record agreement. Please try again.');
    }
    setLoading(false);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4 backdrop-blur-sm">
      <div className="bg-white rounded-2xl max-w-md w-full overflow-hidden shadow-2xl animate-fade-in">
        {/* Header */}
        <div className="bg-emerald-50 p-6 border-b border-emerald-100 text-center">
          <div className="text-3xl mb-2">⚖️</div>
          <h2 className="text-xl font-bold text-emerald-900">Before We Begin</h2>
          <p className="text-emerald-700 text-sm">Please review this important notice.</p>
        </div>
        
        {/* The Legal Text */}
        <div className="p-6 space-y-4 text-gray-600 text-sm leading-relaxed max-h-[60vh] overflow-y-auto">
          <p className="font-bold text-gray-900">
            Disclaimer: Daily Discipline is not medical, psychological, or therapeutic advice.
          </p>
          <p>
            It is a self-improvement tool for general habit-building and lifestyle goals.
          </p>
          <div className="bg-red-50 p-3 rounded-lg border border-red-100 text-red-800 text-xs">
            <strong>Important:</strong> It is not intended for individuals with diagnosed mental health conditions or in need of clinical support.
          </div>
          <p>
            By continuing, you agree to our{' '}
            <a href="/legal/terms" target="_blank" rel="noopener noreferrer" className="text-emerald-600 underline hover:text-emerald-800">
              Terms of Use
            </a>{' '}
            and understand that this is not a substitute for professional care.
          </p>
        </div>
        
        {/* The Agreement Action */}
        <div className="p-6 bg-gray-50 border-t border-gray-100">
          <label className="flex items-center gap-3 mb-4 cursor-pointer">
            <input
              type="checkbox"
              checked={isAgreed}
              onChange={(e) => setIsAgreed(e.target.checked)}
              className="w-5 h-5 text-emerald-600 rounded focus:ring-emerald-500"
            />
            <span className="text-sm text-gray-700 font-medium">
              I have read and agree to these terms.
            </span>
          </label>
          <button
            onClick={handleAgree}
            disabled={!isAgreed || loading}
            className={`w-full py-3 rounded-xl font-bold transition-all ${
              isAgreed && !loading
                ? 'bg-emerald-600 text-white shadow-lg hover:bg-emerald-700'
                : 'bg-gray-200 text-gray-400 cursor-not-allowed'
            }`}
          >
            {loading ? 'Processing...' : 'Enter Daily Discipline'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DisclaimerModal;
